import React from 'react';
import PropTypes from 'prop-types'

import * as style from './image-container.module.scss';

const ImageContainer = ({ classImg, image, alt, classContainer }) => {
  return (
    <div className={`${style.imageContainer} ${classContainer}`}>
      <img alt={alt} src={image} className={classImg} />
    </div>
  );
};

ImageContainer.prototype = {
  classImg: PropTypes.string.isRequired,
  image: PropTypes.object.isRequired,
  alt: PropTypes.any.isRequired,
}

export default ImageContainer;